export default {
    setUser(state, data){
        state.user = data;
    },
    setToken(data){
        localStorage.setItem('token', data);
    },
    removeUser(state){
        state.user = null;
    }   
}
